<template>
  <div>
    <client-filter v-model="params" @search="handleSearch" />

    <vs-card>
      <div id="client-table-loading" class="vs-con-loading__container">
        <vs-row>
          <vs-col vs-xs="12" vs-sm="12" vs-lg="12">
            <client-table @add="add" :data="list" @loadMore="loadMore" @search="handleSearch" @sort="sort"
              @openFilter="openFilter" @lock="lock" />
          </vs-col>
        </vs-row>
      </div>
    </vs-card>
  </div>
</template>

<script>
import ClientTable from './components/ClientTable'
import ClientFilter from './components/ClientFilter'
import AddButton from '@/views/components/buttons/AddButton'
import loading from '@/mixins/Loading'
import client from '@/http/requests/client';

export default {
  components: {
    ClientTable,
    ClientFilter,
    AddButton,
  },

  data: () => ({
    lastPage: 1,
    params: {
      sort: ['DESC', 'ASC'],
      sortBy: ['Clients.IsActive', 'Clients.ClientName'],
    },
    search: '',
    page: 1,
    list: []
  }),
  methods: {
    getData() {
      this.openLoading('client-table-loading')
      let data = Object.assign({}, this.params);
      data.page = this.page
      data.search = this.search
      client.getList(data)
        .then((res) => {
          this.lastPage = res.data.last_page
          this.page = res.data.current_page
          let data = res.data.data
          data.map((obj) => {
            obj.lock = obj.lock === '1' ? 1 : 0
            return obj
          })
          if (this.page > 1) {
            this.list = [...this.list, ...data]
          } else {
            this.list = [...data]
          }
          this.closeLoading('client-table-loading')
        })
        .catch((res) => {
          this.closeLoading('client-table-loading')
        })
    },

    loadMore() {
      if (this.page >= this.lastPage) {
        return
      }
      this.page++
      this.getData()
    },

    handleSearch(text) {
      this.search = text
      this.page = 1
      this.getData()
    },

    sort(e) {
      this.page = 1
      this.params.sortBy = e.sortBy
      this.params.sort = e.sort
      this.getData()
    },

    openFilter() {
      this.$store.dispatch('toggleSidebar', 'client-filter')
    },

    add() {
      this.$router.push({
        name: 'add-client'
      });
    },
    lock(item) {
      this.openLoading('client-table-loading')
      const payload = {
        id: item.id,
        lock: item.lock
      }
      client
        .lock(payload)
        .then((response) => {
          this.closeLoading('client-table-loading')
          this.$vs.notify({
            color: 'success',
            title: 'Success',
            text: 'Client Updated',
          })
        })
        .catch((response) => {
          this.showValidationErrors(response)
          this.closeLoading('client-table-loading')
        })
    }
  },
  mixins: [loading],
  mounted() {
    this.getData()
  },
}
</script>

<style></style>
